<template>
  <span class="trade-header-actions">
    <WatchlistButton :symbol="symbol" @updated="$emit('updated')" />
    <router-link :to="destination" title="前往交易页面" aria-label="前往交易页面"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true"><path d="M9 3H3v6M3 3l7 7M15 3h6v6M21 3l-7 7M3 15v6h6M3 21l7-7M21 15v6h-6M21 21l-7-7" /></svg></router-link>
    <button type="button" title="关闭交易" aria-label="关闭交易" @click="$emit('close')"><i class="el-icon-close" aria-hidden="true" /></button>
  </span>
</template>
<script>
import WatchlistButton from '@/views/stock/WatchlistButton.vue'
import { stockSelection } from '@/views/stock/stockSelection'
export default {
  components: { WatchlistButton },
  props: { symbol: String, name: String, contractId: [Number, String] },
  computed: {
    destination() {
      const stock = stockSelection({ symbol: this.symbol, name: this.name })
      return { path: '/stocks', query: { market: stock.market, symbol: stock.symbol, name: stock.name, ...(Number(this.contractId) > 0 ? { contractId: Number(this.contractId) } : {}) } }
    }
  }
}
</script>
<style scoped>
.trade-header-actions { display: inline-flex; align-items: center; flex-shrink: 0; gap: 2px; }
a, button { display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 34px; padding: 0; border: 0; border-radius: 5px; background: transparent; color: var(--theme-muted); font-size: 22px; text-decoration: none; cursor: pointer; }
a:hover, button:hover { color: var(--theme-accent); }
a:focus-visible, button:focus-visible { outline: 2px solid var(--theme-accent); }
</style>
